import { all, takeEvery } from "redux-saga/effects";
import { actionTypes as eBookingActionTypes } from "./reducer";
import {
  searchForSpouse as searchSpouseService,
  postBuyer as postBuyerService,
  searchForCoBuyer as searchCoBuyerService,
  searchForGroup as searchGroupService,
  getMaintainedValues as getMaintainedValuesService,
  postSpouse as postSpouseService,
  postCoBuyer as postCoBuyerService,
  postCISRequirements as postCISRequirementsService,
  postCPRARequirements as postCPRARequirementsService,
  postPurchaseJourney as postPurchaseJourneyService,
  getReservationDetails as getReservationDetailsService,
  getReservationListFromSap as getReservationListFromSapService,
  getDraftUser as getDraftUserService,
  submitToSap as submitToSapService,
  updateAttachment as updateAttachmentService,
  updateCisInfo as updateCisInfoService
} from "./service";
import processAction from "../../../../utils/processAction";

//get reservation details from sap
function* updateCisInfo(action) {
  yield processAction({
    ...action,
    service: updateCisInfoService,
    success: eBookingActionTypes.UPDATE_CIS_INFO_SUCCESS,
    failed: eBookingActionTypes.UPDATE_CIS_INFO_FAILED
  });
}

//get reservation details from sap
function* updateAttachment(action) {
  yield processAction({
    ...action,
    service: updateAttachmentService,
    success: eBookingActionTypes.UPDATE_ATTACHMENT_SUCCESS,
    failed: eBookingActionTypes.UPDATE_ATTACHMENT_FAILED
  });
}
//get reservation details from sap
function* getDraftUser(action) {
  yield processAction({
    ...action,
    service: getDraftUserService,
    success: eBookingActionTypes.GET_DRAFT_USER_SUCCESS,
    failed: eBookingActionTypes.GET_DRAFT_USER_FAILED
  });
}
//submit to sap
function* submitToSap(action) {
  yield processAction({
    ...action,
    service: submitToSapService,
    success: eBookingActionTypes.SUBMIT_TO_SAP_SUCCESS,
    failed: eBookingActionTypes.SUBMIT_TO_SAP_FAILED
  });
}
//get reservation details from sap
function* getReservationListFromSap(action) {
  yield processAction({
    ...action,
    service: getReservationListFromSapService,
    success: eBookingActionTypes.GET_RESERVATION_LIST_FROM_SAP_SUCCESS,
    failed: eBookingActionTypes.GET_RESERVATION_LIST_FROM_SAP_FAILED
  });
}
//searching of group
function* groupSearch(action) {
  yield processAction({
    ...action,
    service: searchGroupService,
    success: eBookingActionTypes.GROUP_FOR_SEARCH_SUCCESS,
    failed: eBookingActionTypes.GROUP_FOR_SEARCH_FAILED
  });
}
//searching of spouse
function* spouseSearch(action) {
  yield processAction({
    ...action,
    service: searchSpouseService,
    success: eBookingActionTypes.SPOUSE_FOR_SEARCH_SUCCESS,
    failed: eBookingActionTypes.SPOUSE_FOR_SEARCH_FAILED
  });
}
//searching of co buyer
function* coBuyerSearch(action) {
  yield processAction({
    ...action,
    service: searchCoBuyerService,
    success: eBookingActionTypes.CO_BUYER_FOR_SEARCH_SUCCESS,
    failed: eBookingActionTypes.CO_BUYER_FOR_SEARCH_FAILED
  });
}
//post spouse
function* postSpouse(action) {
  yield processAction({
    ...action,
    service: postSpouseService,
    success: eBookingActionTypes.POST_SPOUSE_SUCCESS,
    failed: eBookingActionTypes.POST_SPOUSE_FAILED
  });
}
//post co buyer
function* postCoBuyer(action) {
  yield processAction({
    ...action,
    service: postCoBuyerService,
    success: eBookingActionTypes.POST_CO_BUYER_SUCCESS,
    failed: eBookingActionTypes.POST_CO_BUYER_FAILED
  });
}
//post buyer
function* postBuyer(action) {
  yield processAction({
    ...action,
    service: postBuyerService,
    success: eBookingActionTypes.POST_BUYER_SUCCESS,
    failed: eBookingActionTypes.POST_BUYER_FAILED
  });
}
//post CIS Requirements postCISRequirements postPurchaseJourney
function* postCISRequirements(action) {
  yield processAction({
    ...action,
    service: postCISRequirementsService,
    success: eBookingActionTypes.POST_CIS_REQUIREMENTS_SUCCESS,
    failed: eBookingActionTypes.POST_CIS_REQUIREMENTS_FAILED
  });
}
//post CPRA Requirements postCISRequirements postPurchaseJourney
function* postCPRARequirements(action) {
  yield processAction({
    ...action,
    service: postCPRARequirementsService,
    success: eBookingActionTypes.POST_CPRA_REQUIREMENTS_SUCCESS,
    failed: eBookingActionTypes.POST_CPRA_REQUIREMENTS_FAILED
  });
}
//post purchase Journey postPurchaseJourney
function* postPurchaseJourney(action) {
  yield processAction({
    ...action,
    service: postPurchaseJourneyService,
    success: eBookingActionTypes.POST_PURCHASE_JOURNEY_SUCCESS,
    failed: eBookingActionTypes.POST_PURCHASE_JOURNEY_FAILED
  });
}
//get reservation details
function* getReservationDetails(action) {
  yield processAction({
    ...action,
    service: getReservationDetailsService,
    success: eBookingActionTypes.GET_RESERVATION_DETAIL_SUCCESS,
    failed: eBookingActionTypes.GET_RESERVATION_DETAIL_FAILED
  });
}

//maintained values
function* getMaintainedValues(action) {
  yield processAction({
    ...action,
    service: getMaintainedValuesService,
    success: eBookingActionTypes.GET_MAINTAINED_VALUES_SUCCESS,
    failed: eBookingActionTypes.GET_MAINTAINED_VALUES_FAILED
  });
}
function* watcher() {
  yield all([

    //UPDATE CIS INFO
    takeEvery(eBookingActionTypes.UPDATE_CIS_INFO,
      updateCisInfo),
    //UPDATE ATTACHMENT
    takeEvery(eBookingActionTypes.UPDATE_ATTACHMENT,
      updateAttachment),
    //get reservation list from sap
    takeEvery(eBookingActionTypes.SUBMIT_TO_SAP,
      submitToSap),
    //get reservation list from sap
    takeEvery(eBookingActionTypes.GET_DRAFT_USER,
      getDraftUser),
    //get reservation list from sap
    takeEvery(eBookingActionTypes.GET_RESERVATION_LIST_FROM_SAP,
      getReservationListFromSap),
    //group search
    takeEvery(eBookingActionTypes.GROUP_FOR_SEARCH,
      groupSearch),
    //spouse search
    takeEvery(eBookingActionTypes.SPOUSE_FOR_SEARCH,
      spouseSearch),
    //co buyer search
    takeEvery(eBookingActionTypes.CO_BUYER_FOR_SEARCH,
      coBuyerSearch),
    //post buyer
    takeEvery(eBookingActionTypes.POST_BUYER,
      postBuyer),
    //post spouse
    takeEvery(eBookingActionTypes.POST_SPOUSE,
      postSpouse),
    //post co buyer
    takeEvery(eBookingActionTypes.POST_CO_BUYER,
      postCoBuyer),
    //post cis requirements
    takeEvery(eBookingActionTypes.POST_CIS_REQUIREMENTS,
      postCISRequirements),
    //post cpra requirements
    takeEvery(eBookingActionTypes.POST_CPRA_REQUIREMENTS,
      postCPRARequirements),
    //post purchase journey
    takeEvery(eBookingActionTypes.POST_PURCHASE_JOURNEY,
      postPurchaseJourney),
    //get reservation details
    takeEvery(eBookingActionTypes.GET_RESERVATION_DETAIL,
      getReservationDetails
    ),
    //maintained values
    takeEvery(
      eBookingActionTypes.GET_MAINTAINED_VALUES,
      getMaintainedValues
    )
  ]);
}

export default [watcher()];
